/**
 * WordPress dependencies
 */
import { store, getContext } from '@wordpress/interactivity';

const { state, actions } = store( 'bv-space', {
	state: {
		// activeMalgruppe: '',
		get malgruppeClasses() {
			const context = getContext();
			var malgruppe_classes = 'maalgruppe-item wp-block-columns are-vertically-aligned-center is-not-stacked-on-mobile is-layout-flexwp-block-columns-is-layout-flex';
			if (state.activeMalgruppe === context.item.slug) {
				malgruppe_classes += ' active-maalgruppe';
			}
			if (!state.activeMalgruppe && context.item.slug === '') {
				malgruppe_classes += ' active-maalgruppe';
			}
			return malgruppe_classes;
			// return context.item.slug;
		},
		get isTemaChecked() {
			const context = getContext();
			return state.activeTema === context.item.slug;
		},
		get activeMalgrupper() {
			const context = getContext();
			const activeMalgrupper = context.malgrupper[state.activeButton];
			const hasMalgruppe = activeMalgrupper.some(t => t.slug === state.activeMalgruppe);
			if (!hasMalgruppe) {
				state.activeMalgruppe = false;
			}
			return context.malgrupper[state.activeButton];
		}
	},
	actions: {
		setActiveMalgruppe() {
			const context = getContext();
			if (state.activeMalgruppe === context.item.slug) {
				// If it's already active, deselect it
				state.activeMalgruppe = false;
				state.headerMalgruppe = {
					img: '/wp-content/themes/bv-fagunivers/icons/test-girl.svg',
					name: 'Alle',
					slug: ''
				};
			}
			else {
				state.activeMalgruppe = context.item.slug;
				state.headerMalgruppe = {
						img: context.item.img,
						name: context.item.name,
						slug: context.item.slug
				};
			}
			// Reset activeTema when maalgruppe changes to ensure activeTerms refreshes
			state.activeTema = false;
			// Force refresh of activeTerms if the action exists
			if (actions.refreshActiveTerms) {
				actions.refreshActiveTerms();
			}
			actions.updateURL();
		}
	},
	callbacks: {

	},
} );
